import Grid from '@material-ui/core/Grid';
import { useEffect, useState, memo } from 'react';
import TextField from '@mui/material/TextField';
import { Formik, useFormik, FormikProvider, Field } from 'formik';
import {DebounceInput} from 'react-debounce-input';
import InputAdornment from '@mui/material/InputAdornment';


const SangerRowReadLen = memo((props) => {
    const data = props.data;
    const updateSample = props.updateSample;
    const errorReadLen = props.errorReadLen;
    const submitShowError = props.submitShowError;
  
  return (
<Grid item alignItems="stretch" key={data.id[20]}>
      <DebounceInput
      debounceTimeout={500}
      minLength={1}
      element={TextField}
        required
        id="read-len"
        placeholder={"Read"}
        variant="outlined"
        InputProps={{ inputmode: 'numeric', pattern: '[0-9]*', endAdornment: <InputAdornment style={{size: 10, marginLeft: -10, marginRight: -10}} position="end">bp</InputAdornment>}}
        value={data.readLen}
        sx={{ '& .MuiInputBase-root': { height: 40, borderRadius: 0, width: 80 }, '& legend': { display: 'none' },
        '& fieldset': { top: 0 }, }}
        error={((data.touched[3] || submitShowError)) && errorReadLen(data.readLen)}
        onBlur={(e) => {
          var newTouched = [...data.touched];
          newTouched[3] = true;
          updateSample({ touched: newTouched }, props.id);
        }}
        onChange={async (e) => {
          var newTouched = [...data.touched];
          newTouched[3] = true;
          updateSample({ readLen: e.target.value, touched: newTouched }, props.id);
        }}
      />
    </Grid>

    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.readLen === nextProps.data.readLen;
});

export default SangerRowReadLen;